import { render, staticRenderFns } from "./ItserveButton.vue?vue&type=template&id=e8a1c692&scoped=true"
import script from "./ItserveButton.vue?vue&type=script&lang=js"
export * from "./ItserveButton.vue?vue&type=script&lang=js"
import style0 from "./ItserveButton.vue?vue&type=style&index=0&id=e8a1c692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a1c692",
  null
  
)

export default component.exports